// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: chat_api.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

import {
  Denomination,
  denominationFromJSON,
  denominationToJSON,
  OrderSide,
  orderSideFromJSON,
  orderSideToJSON,
} from './common/trading'
import {
  Exchange,
  exchangeFromJSON,
  exchangeToJSON,
  InstrumentKind,
  instrumentKindFromJSON,
  instrumentKindToJSON,
  TradeVenue,
  tradeVenueFromJSON,
  tradeVenueToJSON,
} from './common/types'
import { ExecutionBatch, ExecutionWarning, Refusal, TriggeredItem } from './public_api'

export const protobufPackage = 'chat_api'

/**
 * Which tab the user is viewing in the positions/orders panel.
 * Matches FE PositionTableTab enum values.
 */
export enum ActiveTab {
  ACTIVE_TAB_UNSPECIFIED = 0,
  ACTIVE_TAB_POSITIONS = 1,
  ACTIVE_TAB_ORDERS = 2,
  ACTIVE_TAB_HISTORY = 3,
  UNRECOGNIZED = -1,
}

export function activeTabFromJSON(object: any): ActiveTab {
  switch (object) {
    case 0:
    case 'ACTIVE_TAB_UNSPECIFIED':
      return ActiveTab.ACTIVE_TAB_UNSPECIFIED
    case 1:
    case 'ACTIVE_TAB_POSITIONS':
      return ActiveTab.ACTIVE_TAB_POSITIONS
    case 2:
    case 'ACTIVE_TAB_ORDERS':
      return ActiveTab.ACTIVE_TAB_ORDERS
    case 3:
    case 'ACTIVE_TAB_HISTORY':
      return ActiveTab.ACTIVE_TAB_HISTORY
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ActiveTab.UNRECOGNIZED
  }
}

export function activeTabToJSON(object: ActiveTab): string {
  switch (object) {
    case ActiveTab.ACTIVE_TAB_UNSPECIFIED:
      return 'ACTIVE_TAB_UNSPECIFIED'
    case ActiveTab.ACTIVE_TAB_POSITIONS:
      return 'ACTIVE_TAB_POSITIONS'
    case ActiveTab.ACTIVE_TAB_ORDERS:
      return 'ACTIVE_TAB_ORDERS'
    case ActiveTab.ACTIVE_TAB_HISTORY:
      return 'ACTIVE_TAB_HISTORY'
    case ActiveTab.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** Outcome status of a ChatResponse. */
export enum ChatStatus {
  CHAT_STATUS_UNSPECIFIED = 0,
  CHAT_STATUS_COMPLETE = 1,
  CHAT_STATUS_NEEDS_CLARIFICATION = 2,
  CHAT_STATUS_ERROR = 3,
  UNRECOGNIZED = -1,
}

export function chatStatusFromJSON(object: any): ChatStatus {
  switch (object) {
    case 0:
    case 'CHAT_STATUS_UNSPECIFIED':
      return ChatStatus.CHAT_STATUS_UNSPECIFIED
    case 1:
    case 'CHAT_STATUS_COMPLETE':
      return ChatStatus.CHAT_STATUS_COMPLETE
    case 2:
    case 'CHAT_STATUS_NEEDS_CLARIFICATION':
      return ChatStatus.CHAT_STATUS_NEEDS_CLARIFICATION
    case 3:
    case 'CHAT_STATUS_ERROR':
      return ChatStatus.CHAT_STATUS_ERROR
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ChatStatus.UNRECOGNIZED
  }
}

export function chatStatusToJSON(object: ChatStatus): string {
  switch (object) {
    case ChatStatus.CHAT_STATUS_UNSPECIFIED:
      return 'CHAT_STATUS_UNSPECIFIED'
    case ChatStatus.CHAT_STATUS_COMPLETE:
      return 'CHAT_STATUS_COMPLETE'
    case ChatStatus.CHAT_STATUS_NEEDS_CLARIFICATION:
      return 'CHAT_STATUS_NEEDS_CLARIFICATION'
    case ChatStatus.CHAT_STATUS_ERROR:
      return 'CHAT_STATUS_ERROR'
    case ChatStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** What a typed answer must look like. Surrounding whitespace is ignored. */
export enum ChatInputKind {
  CHAT_INPUT_KIND_UNSPECIFIED = 0,
  /**
   * CHAT_INPUT_KIND_SYMBOL - An instrument or position symbol, e.g. BTC-PERP; with multi_select,
   * several joined by ", ".
   */
  CHAT_INPUT_KIND_SYMBOL = 1,
  /** CHAT_INPUT_KIND_DURATION - A positive whole number with a unit s, m or h, e.g. 90s, 5m, 1h. */
  CHAT_INPUT_KIND_DURATION = 2,
  /** CHAT_INPUT_KIND_PRICE - A positive decimal price in the instrument's quote currency, e.g. 64250.5. */
  CHAT_INPUT_KIND_PRICE = 3,
  /** CHAT_INPUT_KIND_QUANTITY - A positive decimal quantity, e.g. 0.25. */
  CHAT_INPUT_KIND_QUANTITY = 4,
  /** CHAT_INPUT_KIND_PERCENT - A number in (0, 100], an optional trailing %. */
  CHAT_INPUT_KIND_PERCENT = 5,
  /** CHAT_INPUT_KIND_DATE - A calendar date, YYYY-MM-DD. */
  CHAT_INPUT_KIND_DATE = 6,
  UNRECOGNIZED = -1,
}

export function chatInputKindFromJSON(object: any): ChatInputKind {
  switch (object) {
    case 0:
    case 'CHAT_INPUT_KIND_UNSPECIFIED':
      return ChatInputKind.CHAT_INPUT_KIND_UNSPECIFIED
    case 1:
    case 'CHAT_INPUT_KIND_SYMBOL':
      return ChatInputKind.CHAT_INPUT_KIND_SYMBOL
    case 2:
    case 'CHAT_INPUT_KIND_DURATION':
      return ChatInputKind.CHAT_INPUT_KIND_DURATION
    case 3:
    case 'CHAT_INPUT_KIND_PRICE':
      return ChatInputKind.CHAT_INPUT_KIND_PRICE
    case 4:
    case 'CHAT_INPUT_KIND_QUANTITY':
      return ChatInputKind.CHAT_INPUT_KIND_QUANTITY
    case 5:
    case 'CHAT_INPUT_KIND_PERCENT':
      return ChatInputKind.CHAT_INPUT_KIND_PERCENT
    case 6:
    case 'CHAT_INPUT_KIND_DATE':
      return ChatInputKind.CHAT_INPUT_KIND_DATE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ChatInputKind.UNRECOGNIZED
  }
}

export function chatInputKindToJSON(object: ChatInputKind): string {
  switch (object) {
    case ChatInputKind.CHAT_INPUT_KIND_UNSPECIFIED:
      return 'CHAT_INPUT_KIND_UNSPECIFIED'
    case ChatInputKind.CHAT_INPUT_KIND_SYMBOL:
      return 'CHAT_INPUT_KIND_SYMBOL'
    case ChatInputKind.CHAT_INPUT_KIND_DURATION:
      return 'CHAT_INPUT_KIND_DURATION'
    case ChatInputKind.CHAT_INPUT_KIND_PRICE:
      return 'CHAT_INPUT_KIND_PRICE'
    case ChatInputKind.CHAT_INPUT_KIND_QUANTITY:
      return 'CHAT_INPUT_KIND_QUANTITY'
    case ChatInputKind.CHAT_INPUT_KIND_PERCENT:
      return 'CHAT_INPUT_KIND_PERCENT'
    case ChatInputKind.CHAT_INPUT_KIND_DATE:
      return 'CHAT_INPUT_KIND_DATE'
    case ChatInputKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** Top-level request from the frontend. */
export interface ChatRequest {
  /**
   * Routing/tracing only. Forwarded to backend for JWT scoping.
   * NEVER injected into the LLM prompt.
   * FE source: state/storage.ts → selectedAccountAtom → PublicAccount.accountId
   */
  accountId: string
  /**
   * The user's natural language trading instruction.
   * FE source: features/order/chat/components/multimodal-input.tsx → text input
   * Example: "buy 0.5 BTC perp at market"
   */
  prompt: string
  /**
   * Snapshot of UI state at send time. Injected into the Jinja2 system prompt
   * to help the LLM resolve ambiguous references ("this", "the perp", etc.).
   */
  context: UIContext | undefined
  /**
   * Optional: session ID for multi-turn follow-ups. When set, the AI layer
   * loads the previous turn's response context for prompt injection.
   * Omit or leave empty for new sessions (AI generates a fresh UUID).
   */
  sessionId: string
  /**
   * The user's UI language as a BCP 47 tag from the frontend's supported set
   * (en, de, ko, zh-CN). A hint for the reply language only: the prompt may be
   * written in another language, and the prompt's language wins.
   */
  locale?: string | undefined
}

export interface UIContext {
  /**
   * The trade venue the user's active account is connected to. An account is
   * identified by its trade venue, not by the underlying market.
   * FE source: state/storage.ts → selectedAccountAtom → PublicAccount.trade_venue
   * Prompt use: determines which execution venue the user is acting from.
   */
  tradeVenue: TradeVenue
  /**
   * The market the user's focused instrument trades on. Optional — only set
   * when the prompt context needs market identity distinct from trade venue
   * (e.g. IBKR account focused on a GLBX-listed contract).
   * FE source: derived from focused instrument's `Instrument.exchange`.
   */
  focusedExchange: Exchange
  /**
   * The instrument symbol currently in focus (selected in watchlist or chart).
   * FE source: features/dashboard/hook/use-watchlist-tab.tsx → selectedSymbol.symbol
   * Example: "BTC-PERPETUAL", "ETH-28MAR26-4000-C"
   * Prompt use: resolves "buy this", "sell the perp", "close that".
   */
  focusedSymbol: string
  /**
   * Base asset of the focused instrument, derived from symbol.
   * FE derivation: selectedSymbol.symbol.split(/[-_]/)[0]
   * Example: "BTC", "ETH"
   * Prompt use: asset disambiguation when symbol is ambiguous.
   */
  focusedAsset: string
  /**
   * Instrument type of the focused instrument.
   * FE source: watchlist item type field
   * Note: perpetuals are classified as INSTRUMENT_KIND_FUTURE.
   * Prompt use: instrument type context for the LLM.
   */
  focusedType: InstrumentKind
  /**
   * Instruments the user has explicitly selected (e.g. multi-select in watchlist).
   * FE source: state/dashboard.ts → watchListTickerMapAtom (selected subset)
   * Prompt use: resolves "buy all of these", "sell my selection".
   */
  selectedInstruments: SelectedInstrument[]
  /**
   * Orderbook row the user clicked before typing. Strong signal for limit orders.
   * FE source: state/linking-group.ts → orderbookPrice, orderbookAmount
   * Prompt use: "buy at that price" → limit order at orderbook_click.price.
   */
  orderbookClick: OrderbookClick | undefined
  /**
   * Which tab the user is viewing in the positions/orders panel.
   * FE source: PositionTableTab enum → POSITIONS | ORDERS | HISTORY
   * Prompt use: disambiguates "close that" (position) vs "cancel that" (order).
   */
  activeTab: ActiveTab
  /**
   * Active filters on the positions table. Narrows "close all of these".
   * FE source: state/storage.ts → positionFilterAtom
   * Prompt use: scopes bulk operations to filtered subset.
   */
  positionFilters: PositionFilters | undefined
  /**
   * Chart timeframe in view. Logged for analytics, NOT injected into prompt.
   * FE source: chart component → timeframe selector (seconds as string)
   * Example: "60", "3600", "86400"
   */
  chartTimeframe: string
}

/** An instrument the user has selected in the watchlist. */
export interface SelectedInstrument {
  /**
   * Instrument symbol. Example: "BTC-PERPETUAL", "ETH-28MAR26-4000-C"
   * FE source: WatchListItem.symbol
   */
  symbol: string
  /**
   * The market this symbol belongs to. A watchlist spans exchanges, so the
   * symbol alone does not identify an instrument.
   * FE source: WatchListItem.exchange
   */
  exchange: Exchange
  /**
   * Last traded price as a decimal string.
   * Example: "67150.00"
   * FE source: WatchListItem.lastPrice
   */
  lastPrice: string
  /**
   * Position side if the user holds this instrument.
   * FE source: derived from position data
   */
  side: OrderSide
}

/** Captures an orderbook click event — the user clicked a specific price level. */
export interface OrderbookClick {
  /**
   * Price level clicked. Decimal string. Example: "67150.00"
   * FE source: state/linking-group.ts → orderbookPrice
   */
  price: string
  /**
   * Quantity at that price level. Decimal string. Example: "0.5"
   * FE source: state/linking-group.ts → orderbookAmount
   */
  amount: string
  /**
   * Denomination of the amount: base or quote currency.
   * FE derivation: inferred from baseCurrency context
   */
  denom: Denomination
}

/** Active filters on the positions/orders table. */
export interface PositionFilters {
  /**
   * Asset tickers the user has filtered to. Example: ["BTC", "ETH"]
   * FE source: positionFilterAtom.assets.value (string[])
   */
  tickers: string[]
  /**
   * Expiry dates the user has filtered to. Example: ["2026-06-27"]
   * FE source: positionFilterAtom.expiries.value (string, single value → repeated for flexibility)
   */
  expiries: string[]
}

/** Top-level response from the AI layer back to the frontend. */
export interface ChatResponse {
  /**
   * UUID for this chat session. Generated by the AI layer.
   * Used for session correlation, logging, and future multi-turn support.
   */
  sessionId: string
  /**
   * Outcome of the request.
   *   - COMPLETE: execution_batch is populated, ready for user confirmation.
   *   - NEEDS_CLARIFICATION: message contains a follow-up question.
   *   - ERROR: message contains error description.
   */
  status: ChatStatus
  /**
   * The validated execution plan from the backend. Only present when
   * status = COMPLETE. Contains the order(s) for user review.
   */
  executionBatch: ExecutionBatch | undefined
  /**
   * Risk warnings from backend validation. Displayed as chat text below
   * the order card. May be present even when status = COMPLETE.
   */
  warnings: ExecutionWarning[]
  /**
   * AI-generated text response. Always present.
   * For COMPLETE: summary of what will be executed.
   * For NEEDS_CLARIFICATION: follow-up question to the user.
   * For ERROR: human-readable error description.
   */
  message: string
  /**
   * Trigger-bound items mirrored from `DraftExecutionPlan.triggered_items`
   * so the chat UI can render them alongside the immediate batch.
   */
  triggeredItems: TriggeredItem[]
  /** Structured refusals mirrored from `DraftExecutionPlan.refusals`. */
  refusals: Refusal[]
  /**
   * Known answers to the clarifying question in `message`, rendered as
   * buttons, and the format of a typed answer. Only set with status =
   * NEEDS_CLARIFICATION; absent when the question has neither (the user types
   * free text instead).
   */
  choices: ChatChoices | undefined
}

/** The answers to one clarifying question. */
export interface ChatChoices {
  /** In display order. At most 6. */
  options: ChatChoice[]
  /**
   * false: tapping an option sends its reply at once.
   * true: the user selects one or more options, then sends; the next prompt is
   * the selected replies in `options` order, joined by ", ".
   */
  multiSelect: boolean
  /**
   * The format of a typed answer, for an input box shown with the options that
   * validates before sending. Absent: no fixed format (free text). May be set
   * with no options.
   */
  input: ChatInput | undefined
}

/**
 * A typed answer is sent as the next ChatRequest.prompt in the same session,
 * exactly like a tapped reply.
 */
export interface ChatInput {
  kind: ChatInputKind
  /** Hint for the empty box, e.g. "e.g. 90s, 5m or 1h". */
  placeholder: string
}

/**
 * One answer. The reply is sent as the next ChatRequest.prompt in the same
 * session, exactly as if the user had typed it, so no other request exists
 * and the turn replays from history like any typed answer.
 */
export interface ChatChoice {
  /** Button text. */
  label: string
  /** The prompt to send when chosen. */
  reply: string
}

/** A single turn in a conversation session. */
export interface SessionTurn {
  turnNumber: number
  prompt: string
  aiResponse: string
  status: ChatStatus
  warnings: ExecutionWarning[]
  createdAt: string
}

/** Full session detail with metadata and all turns. */
export interface SessionDetail {
  sessionId: string
  userId: string
  title: string
  createdAt: string
  isEval: boolean
  turns: SessionTurn[]
}

/** Lightweight session header for list views. */
export interface SessionSummary {
  sessionId: string
  title: string
  createdAt: string
  isEval: boolean
}

/** Response for GET /v1/sessions/{session_id}. */
export interface GetSessionResponse {
  session: SessionDetail | undefined
}

/** Response for GET /v1/sessions. */
export interface ListSessionsResponse {
  sessions: SessionSummary[]
}

function createBaseChatRequest(): ChatRequest {
  return { accountId: '', prompt: '', context: undefined, sessionId: '', locale: undefined }
}

export const ChatRequest: MessageFns<ChatRequest> = {
  encode(message: ChatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.prompt !== '') {
      writer.uint32(18).string(message.prompt)
    }
    if (message.context !== undefined) {
      UIContext.encode(message.context, writer.uint32(26).fork()).join()
    }
    if (message.sessionId !== '') {
      writer.uint32(34).string(message.sessionId)
    }
    if (message.locale !== undefined) {
      writer.uint32(42).string(message.locale)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChatRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.prompt = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.context = UIContext.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.sessionId = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.locale = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChatRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : '',
      context: isSet(object.context) ? UIContext.fromJSON(object.context) : undefined,
      sessionId: isSet(object.sessionId)
        ? globalThis.String(object.sessionId)
        : isSet(object.session_id)
          ? globalThis.String(object.session_id)
          : '',
      locale: isSet(object.locale) ? globalThis.String(object.locale) : undefined,
    }
  },

  toJSON(message: ChatRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.prompt !== '') {
      obj.prompt = message.prompt
    }
    if (message.context !== undefined) {
      obj.context = UIContext.toJSON(message.context)
    }
    if (message.sessionId !== '') {
      obj.sessionId = message.sessionId
    }
    if (message.locale !== undefined) {
      obj.locale = message.locale
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChatRequest>, I>>(base?: I): ChatRequest {
    return ChatRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChatRequest>, I>>(object: I): ChatRequest {
    const message = createBaseChatRequest()
    message.accountId = object.accountId ?? ''
    message.prompt = object.prompt ?? ''
    message.context =
      object.context !== undefined && object.context !== null
        ? UIContext.fromPartial(object.context)
        : undefined
    message.sessionId = object.sessionId ?? ''
    message.locale = object.locale ?? undefined
    return message
  },
}

function createBaseUIContext(): UIContext {
  return {
    tradeVenue: 0,
    focusedExchange: 0,
    focusedSymbol: '',
    focusedAsset: '',
    focusedType: 0,
    selectedInstruments: [],
    orderbookClick: undefined,
    activeTab: 0,
    positionFilters: undefined,
    chartTimeframe: '',
  }
}

export const UIContext: MessageFns<UIContext> = {
  encode(message: UIContext, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tradeVenue !== 0) {
      writer.uint32(144).int32(message.tradeVenue)
    }
    if (message.focusedExchange !== 0) {
      writer.uint32(152).int32(message.focusedExchange)
    }
    if (message.focusedSymbol !== '') {
      writer.uint32(18).string(message.focusedSymbol)
    }
    if (message.focusedAsset !== '') {
      writer.uint32(26).string(message.focusedAsset)
    }
    if (message.focusedType !== 0) {
      writer.uint32(32).int32(message.focusedType)
    }
    for (const v of message.selectedInstruments) {
      SelectedInstrument.encode(v!, writer.uint32(42).fork()).join()
    }
    if (message.orderbookClick !== undefined) {
      OrderbookClick.encode(message.orderbookClick, writer.uint32(50).fork()).join()
    }
    if (message.activeTab !== 0) {
      writer.uint32(56).int32(message.activeTab)
    }
    if (message.positionFilters !== undefined) {
      PositionFilters.encode(message.positionFilters, writer.uint32(66).fork()).join()
    }
    if (message.chartTimeframe !== '') {
      writer.uint32(74).string(message.chartTimeframe)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UIContext {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUIContext()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 18: {
          if (tag !== 144) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 19: {
          if (tag !== 152) {
            break
          }

          message.focusedExchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.focusedSymbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.focusedAsset = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.focusedType = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.selectedInstruments.push(SelectedInstrument.decode(reader, reader.uint32()))
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.orderbookClick = OrderbookClick.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.activeTab = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.positionFilters = PositionFilters.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.chartTimeframe = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UIContext {
    return {
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      focusedExchange: isSet(object.focusedExchange)
        ? exchangeFromJSON(object.focusedExchange)
        : isSet(object.focused_exchange)
          ? exchangeFromJSON(object.focused_exchange)
          : 0,
      focusedSymbol: isSet(object.focusedSymbol)
        ? globalThis.String(object.focusedSymbol)
        : isSet(object.focused_symbol)
          ? globalThis.String(object.focused_symbol)
          : '',
      focusedAsset: isSet(object.focusedAsset)
        ? globalThis.String(object.focusedAsset)
        : isSet(object.focused_asset)
          ? globalThis.String(object.focused_asset)
          : '',
      focusedType: isSet(object.focusedType)
        ? instrumentKindFromJSON(object.focusedType)
        : isSet(object.focused_type)
          ? instrumentKindFromJSON(object.focused_type)
          : 0,
      selectedInstruments: globalThis.Array.isArray(object?.selectedInstruments)
        ? object.selectedInstruments.map((e: any) => SelectedInstrument.fromJSON(e))
        : globalThis.Array.isArray(object?.selected_instruments)
          ? object.selected_instruments.map((e: any) => SelectedInstrument.fromJSON(e))
          : [],
      orderbookClick: isSet(object.orderbookClick)
        ? OrderbookClick.fromJSON(object.orderbookClick)
        : isSet(object.orderbook_click)
          ? OrderbookClick.fromJSON(object.orderbook_click)
          : undefined,
      activeTab: isSet(object.activeTab)
        ? activeTabFromJSON(object.activeTab)
        : isSet(object.active_tab)
          ? activeTabFromJSON(object.active_tab)
          : 0,
      positionFilters: isSet(object.positionFilters)
        ? PositionFilters.fromJSON(object.positionFilters)
        : isSet(object.position_filters)
          ? PositionFilters.fromJSON(object.position_filters)
          : undefined,
      chartTimeframe: isSet(object.chartTimeframe)
        ? globalThis.String(object.chartTimeframe)
        : isSet(object.chart_timeframe)
          ? globalThis.String(object.chart_timeframe)
          : '',
    }
  },

  toJSON(message: UIContext): unknown {
    const obj: any = {}
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.focusedExchange !== 0) {
      obj.focusedExchange = exchangeToJSON(message.focusedExchange)
    }
    if (message.focusedSymbol !== '') {
      obj.focusedSymbol = message.focusedSymbol
    }
    if (message.focusedAsset !== '') {
      obj.focusedAsset = message.focusedAsset
    }
    if (message.focusedType !== 0) {
      obj.focusedType = instrumentKindToJSON(message.focusedType)
    }
    if (message.selectedInstruments?.length) {
      obj.selectedInstruments = message.selectedInstruments.map((e) => SelectedInstrument.toJSON(e))
    }
    if (message.orderbookClick !== undefined) {
      obj.orderbookClick = OrderbookClick.toJSON(message.orderbookClick)
    }
    if (message.activeTab !== 0) {
      obj.activeTab = activeTabToJSON(message.activeTab)
    }
    if (message.positionFilters !== undefined) {
      obj.positionFilters = PositionFilters.toJSON(message.positionFilters)
    }
    if (message.chartTimeframe !== '') {
      obj.chartTimeframe = message.chartTimeframe
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UIContext>, I>>(base?: I): UIContext {
    return UIContext.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UIContext>, I>>(object: I): UIContext {
    const message = createBaseUIContext()
    message.tradeVenue = object.tradeVenue ?? 0
    message.focusedExchange = object.focusedExchange ?? 0
    message.focusedSymbol = object.focusedSymbol ?? ''
    message.focusedAsset = object.focusedAsset ?? ''
    message.focusedType = object.focusedType ?? 0
    message.selectedInstruments =
      object.selectedInstruments?.map((e) => SelectedInstrument.fromPartial(e)) || []
    message.orderbookClick =
      object.orderbookClick !== undefined && object.orderbookClick !== null
        ? OrderbookClick.fromPartial(object.orderbookClick)
        : undefined
    message.activeTab = object.activeTab ?? 0
    message.positionFilters =
      object.positionFilters !== undefined && object.positionFilters !== null
        ? PositionFilters.fromPartial(object.positionFilters)
        : undefined
    message.chartTimeframe = object.chartTimeframe ?? ''
    return message
  },
}

function createBaseSelectedInstrument(): SelectedInstrument {
  return { symbol: '', exchange: 0, lastPrice: '', side: 0 }
}

export const SelectedInstrument: MessageFns<SelectedInstrument> = {
  encode(message: SelectedInstrument, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.exchange !== 0) {
      writer.uint32(32).int32(message.exchange)
    }
    if (message.lastPrice !== '') {
      writer.uint32(18).string(message.lastPrice)
    }
    if (message.side !== 0) {
      writer.uint32(24).int32(message.side)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SelectedInstrument {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSelectedInstrument()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.lastPrice = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SelectedInstrument {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      lastPrice: isSet(object.lastPrice)
        ? globalThis.String(object.lastPrice)
        : isSet(object.last_price)
          ? globalThis.String(object.last_price)
          : '',
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
    }
  },

  toJSON(message: SelectedInstrument): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.lastPrice !== '') {
      obj.lastPrice = message.lastPrice
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SelectedInstrument>, I>>(base?: I): SelectedInstrument {
    return SelectedInstrument.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SelectedInstrument>, I>>(object: I): SelectedInstrument {
    const message = createBaseSelectedInstrument()
    message.symbol = object.symbol ?? ''
    message.exchange = object.exchange ?? 0
    message.lastPrice = object.lastPrice ?? ''
    message.side = object.side ?? 0
    return message
  },
}

function createBaseOrderbookClick(): OrderbookClick {
  return { price: '', amount: '', denom: 0 }
}

export const OrderbookClick: MessageFns<OrderbookClick> = {
  encode(message: OrderbookClick, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.price !== '') {
      writer.uint32(10).string(message.price)
    }
    if (message.amount !== '') {
      writer.uint32(18).string(message.amount)
    }
    if (message.denom !== 0) {
      writer.uint32(24).int32(message.denom)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderbookClick {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderbookClick()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.amount = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.denom = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderbookClick {
    return {
      price: isSet(object.price) ? globalThis.String(object.price) : '',
      amount: isSet(object.amount) ? globalThis.String(object.amount) : '',
      denom: isSet(object.denom) ? denominationFromJSON(object.denom) : 0,
    }
  },

  toJSON(message: OrderbookClick): unknown {
    const obj: any = {}
    if (message.price !== '') {
      obj.price = message.price
    }
    if (message.amount !== '') {
      obj.amount = message.amount
    }
    if (message.denom !== 0) {
      obj.denom = denominationToJSON(message.denom)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderbookClick>, I>>(base?: I): OrderbookClick {
    return OrderbookClick.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderbookClick>, I>>(object: I): OrderbookClick {
    const message = createBaseOrderbookClick()
    message.price = object.price ?? ''
    message.amount = object.amount ?? ''
    message.denom = object.denom ?? 0
    return message
  },
}

function createBasePositionFilters(): PositionFilters {
  return { tickers: [], expiries: [] }
}

export const PositionFilters: MessageFns<PositionFilters> = {
  encode(message: PositionFilters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tickers) {
      writer.uint32(10).string(v!)
    }
    for (const v of message.expiries) {
      writer.uint32(18).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionFilters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePositionFilters()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tickers.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.expiries.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PositionFilters {
    return {
      tickers: globalThis.Array.isArray(object?.tickers)
        ? object.tickers.map((e: any) => globalThis.String(e))
        : [],
      expiries: globalThis.Array.isArray(object?.expiries)
        ? object.expiries.map((e: any) => globalThis.String(e))
        : [],
    }
  },

  toJSON(message: PositionFilters): unknown {
    const obj: any = {}
    if (message.tickers?.length) {
      obj.tickers = message.tickers
    }
    if (message.expiries?.length) {
      obj.expiries = message.expiries
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PositionFilters>, I>>(base?: I): PositionFilters {
    return PositionFilters.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PositionFilters>, I>>(object: I): PositionFilters {
    const message = createBasePositionFilters()
    message.tickers = object.tickers?.map((e) => e) || []
    message.expiries = object.expiries?.map((e) => e) || []
    return message
  },
}

function createBaseChatResponse(): ChatResponse {
  return {
    sessionId: '',
    status: 0,
    executionBatch: undefined,
    warnings: [],
    message: '',
    triggeredItems: [],
    refusals: [],
    choices: undefined,
  }
}

export const ChatResponse: MessageFns<ChatResponse> = {
  encode(message: ChatResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sessionId !== '') {
      writer.uint32(10).string(message.sessionId)
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status)
    }
    if (message.executionBatch !== undefined) {
      ExecutionBatch.encode(message.executionBatch, writer.uint32(26).fork()).join()
    }
    for (const v of message.warnings) {
      ExecutionWarning.encode(v!, writer.uint32(34).fork()).join()
    }
    if (message.message !== '') {
      writer.uint32(42).string(message.message)
    }
    for (const v of message.triggeredItems) {
      TriggeredItem.encode(v!, writer.uint32(50).fork()).join()
    }
    for (const v of message.refusals) {
      Refusal.encode(v!, writer.uint32(58).fork()).join()
    }
    if (message.choices !== undefined) {
      ChatChoices.encode(message.choices, writer.uint32(66).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChatResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.sessionId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.executionBatch = ExecutionBatch.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.warnings.push(ExecutionWarning.decode(reader, reader.uint32()))
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.message = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.triggeredItems.push(TriggeredItem.decode(reader, reader.uint32()))
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.refusals.push(Refusal.decode(reader, reader.uint32()))
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.choices = ChatChoices.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChatResponse {
    return {
      sessionId: isSet(object.sessionId)
        ? globalThis.String(object.sessionId)
        : isSet(object.session_id)
          ? globalThis.String(object.session_id)
          : '',
      status: isSet(object.status) ? chatStatusFromJSON(object.status) : 0,
      executionBatch: isSet(object.executionBatch)
        ? ExecutionBatch.fromJSON(object.executionBatch)
        : isSet(object.execution_batch)
          ? ExecutionBatch.fromJSON(object.execution_batch)
          : undefined,
      warnings: globalThis.Array.isArray(object?.warnings)
        ? object.warnings.map((e: any) => ExecutionWarning.fromJSON(e))
        : [],
      message: isSet(object.message) ? globalThis.String(object.message) : '',
      triggeredItems: globalThis.Array.isArray(object?.triggeredItems)
        ? object.triggeredItems.map((e: any) => TriggeredItem.fromJSON(e))
        : globalThis.Array.isArray(object?.triggered_items)
          ? object.triggered_items.map((e: any) => TriggeredItem.fromJSON(e))
          : [],
      refusals: globalThis.Array.isArray(object?.refusals)
        ? object.refusals.map((e: any) => Refusal.fromJSON(e))
        : [],
      choices: isSet(object.choices) ? ChatChoices.fromJSON(object.choices) : undefined,
    }
  },

  toJSON(message: ChatResponse): unknown {
    const obj: any = {}
    if (message.sessionId !== '') {
      obj.sessionId = message.sessionId
    }
    if (message.status !== 0) {
      obj.status = chatStatusToJSON(message.status)
    }
    if (message.executionBatch !== undefined) {
      obj.executionBatch = ExecutionBatch.toJSON(message.executionBatch)
    }
    if (message.warnings?.length) {
      obj.warnings = message.warnings.map((e) => ExecutionWarning.toJSON(e))
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    if (message.triggeredItems?.length) {
      obj.triggeredItems = message.triggeredItems.map((e) => TriggeredItem.toJSON(e))
    }
    if (message.refusals?.length) {
      obj.refusals = message.refusals.map((e) => Refusal.toJSON(e))
    }
    if (message.choices !== undefined) {
      obj.choices = ChatChoices.toJSON(message.choices)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChatResponse>, I>>(base?: I): ChatResponse {
    return ChatResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChatResponse>, I>>(object: I): ChatResponse {
    const message = createBaseChatResponse()
    message.sessionId = object.sessionId ?? ''
    message.status = object.status ?? 0
    message.executionBatch =
      object.executionBatch !== undefined && object.executionBatch !== null
        ? ExecutionBatch.fromPartial(object.executionBatch)
        : undefined
    message.warnings = object.warnings?.map((e) => ExecutionWarning.fromPartial(e)) || []
    message.message = object.message ?? ''
    message.triggeredItems = object.triggeredItems?.map((e) => TriggeredItem.fromPartial(e)) || []
    message.refusals = object.refusals?.map((e) => Refusal.fromPartial(e)) || []
    message.choices =
      object.choices !== undefined && object.choices !== null
        ? ChatChoices.fromPartial(object.choices)
        : undefined
    return message
  },
}

function createBaseChatChoices(): ChatChoices {
  return { options: [], multiSelect: false, input: undefined }
}

export const ChatChoices: MessageFns<ChatChoices> = {
  encode(message: ChatChoices, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.options) {
      ChatChoice.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.multiSelect !== false) {
      writer.uint32(16).bool(message.multiSelect)
    }
    if (message.input !== undefined) {
      ChatInput.encode(message.input, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatChoices {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChatChoices()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.options.push(ChatChoice.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.multiSelect = reader.bool()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.input = ChatInput.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChatChoices {
    return {
      options: globalThis.Array.isArray(object?.options)
        ? object.options.map((e: any) => ChatChoice.fromJSON(e))
        : [],
      multiSelect: isSet(object.multiSelect)
        ? globalThis.Boolean(object.multiSelect)
        : isSet(object.multi_select)
          ? globalThis.Boolean(object.multi_select)
          : false,
      input: isSet(object.input) ? ChatInput.fromJSON(object.input) : undefined,
    }
  },

  toJSON(message: ChatChoices): unknown {
    const obj: any = {}
    if (message.options?.length) {
      obj.options = message.options.map((e) => ChatChoice.toJSON(e))
    }
    if (message.multiSelect !== false) {
      obj.multiSelect = message.multiSelect
    }
    if (message.input !== undefined) {
      obj.input = ChatInput.toJSON(message.input)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChatChoices>, I>>(base?: I): ChatChoices {
    return ChatChoices.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChatChoices>, I>>(object: I): ChatChoices {
    const message = createBaseChatChoices()
    message.options = object.options?.map((e) => ChatChoice.fromPartial(e)) || []
    message.multiSelect = object.multiSelect ?? false
    message.input =
      object.input !== undefined && object.input !== null
        ? ChatInput.fromPartial(object.input)
        : undefined
    return message
  },
}

function createBaseChatInput(): ChatInput {
  return { kind: 0, placeholder: '' }
}

export const ChatInput: MessageFns<ChatInput> = {
  encode(message: ChatInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind)
    }
    if (message.placeholder !== '') {
      writer.uint32(18).string(message.placeholder)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChatInput()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.kind = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.placeholder = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChatInput {
    return {
      kind: isSet(object.kind) ? chatInputKindFromJSON(object.kind) : 0,
      placeholder: isSet(object.placeholder) ? globalThis.String(object.placeholder) : '',
    }
  },

  toJSON(message: ChatInput): unknown {
    const obj: any = {}
    if (message.kind !== 0) {
      obj.kind = chatInputKindToJSON(message.kind)
    }
    if (message.placeholder !== '') {
      obj.placeholder = message.placeholder
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChatInput>, I>>(base?: I): ChatInput {
    return ChatInput.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChatInput>, I>>(object: I): ChatInput {
    const message = createBaseChatInput()
    message.kind = object.kind ?? 0
    message.placeholder = object.placeholder ?? ''
    return message
  },
}

function createBaseChatChoice(): ChatChoice {
  return { label: '', reply: '' }
}

export const ChatChoice: MessageFns<ChatChoice> = {
  encode(message: ChatChoice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== '') {
      writer.uint32(10).string(message.label)
    }
    if (message.reply !== '') {
      writer.uint32(18).string(message.reply)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatChoice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChatChoice()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.reply = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChatChoice {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      reply: isSet(object.reply) ? globalThis.String(object.reply) : '',
    }
  },

  toJSON(message: ChatChoice): unknown {
    const obj: any = {}
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.reply !== '') {
      obj.reply = message.reply
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChatChoice>, I>>(base?: I): ChatChoice {
    return ChatChoice.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChatChoice>, I>>(object: I): ChatChoice {
    const message = createBaseChatChoice()
    message.label = object.label ?? ''
    message.reply = object.reply ?? ''
    return message
  },
}

function createBaseSessionTurn(): SessionTurn {
  return { turnNumber: 0, prompt: '', aiResponse: '', status: 0, warnings: [], createdAt: '' }
}

export const SessionTurn: MessageFns<SessionTurn> = {
  encode(message: SessionTurn, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.turnNumber !== 0) {
      writer.uint32(8).int32(message.turnNumber)
    }
    if (message.prompt !== '') {
      writer.uint32(18).string(message.prompt)
    }
    if (message.aiResponse !== '') {
      writer.uint32(26).string(message.aiResponse)
    }
    if (message.status !== 0) {
      writer.uint32(32).int32(message.status)
    }
    for (const v of message.warnings) {
      ExecutionWarning.encode(v!, writer.uint32(50).fork()).join()
    }
    if (message.createdAt !== '') {
      writer.uint32(58).string(message.createdAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SessionTurn {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSessionTurn()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.turnNumber = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.prompt = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.aiResponse = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.warnings.push(ExecutionWarning.decode(reader, reader.uint32()))
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.createdAt = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SessionTurn {
    return {
      turnNumber: isSet(object.turnNumber)
        ? globalThis.Number(object.turnNumber)
        : isSet(object.turn_number)
          ? globalThis.Number(object.turn_number)
          : 0,
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : '',
      aiResponse: isSet(object.aiResponse)
        ? globalThis.String(object.aiResponse)
        : isSet(object.ai_response)
          ? globalThis.String(object.ai_response)
          : '',
      status: isSet(object.status) ? chatStatusFromJSON(object.status) : 0,
      warnings: globalThis.Array.isArray(object?.warnings)
        ? object.warnings.map((e: any) => ExecutionWarning.fromJSON(e))
        : [],
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '',
    }
  },

  toJSON(message: SessionTurn): unknown {
    const obj: any = {}
    if (message.turnNumber !== 0) {
      obj.turnNumber = Math.round(message.turnNumber)
    }
    if (message.prompt !== '') {
      obj.prompt = message.prompt
    }
    if (message.aiResponse !== '') {
      obj.aiResponse = message.aiResponse
    }
    if (message.status !== 0) {
      obj.status = chatStatusToJSON(message.status)
    }
    if (message.warnings?.length) {
      obj.warnings = message.warnings.map((e) => ExecutionWarning.toJSON(e))
    }
    if (message.createdAt !== '') {
      obj.createdAt = message.createdAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SessionTurn>, I>>(base?: I): SessionTurn {
    return SessionTurn.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SessionTurn>, I>>(object: I): SessionTurn {
    const message = createBaseSessionTurn()
    message.turnNumber = object.turnNumber ?? 0
    message.prompt = object.prompt ?? ''
    message.aiResponse = object.aiResponse ?? ''
    message.status = object.status ?? 0
    message.warnings = object.warnings?.map((e) => ExecutionWarning.fromPartial(e)) || []
    message.createdAt = object.createdAt ?? ''
    return message
  },
}

function createBaseSessionDetail(): SessionDetail {
  return { sessionId: '', userId: '', title: '', createdAt: '', isEval: false, turns: [] }
}

export const SessionDetail: MessageFns<SessionDetail> = {
  encode(message: SessionDetail, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sessionId !== '') {
      writer.uint32(10).string(message.sessionId)
    }
    if (message.userId !== '') {
      writer.uint32(18).string(message.userId)
    }
    if (message.title !== '') {
      writer.uint32(26).string(message.title)
    }
    if (message.createdAt !== '') {
      writer.uint32(34).string(message.createdAt)
    }
    if (message.isEval !== false) {
      writer.uint32(40).bool(message.isEval)
    }
    for (const v of message.turns) {
      SessionTurn.encode(v!, writer.uint32(50).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SessionDetail {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSessionDetail()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.sessionId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.userId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.title = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.createdAt = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.isEval = reader.bool()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.turns.push(SessionTurn.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SessionDetail {
    return {
      sessionId: isSet(object.sessionId)
        ? globalThis.String(object.sessionId)
        : isSet(object.session_id)
          ? globalThis.String(object.session_id)
          : '',
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : '',
      title: isSet(object.title) ? globalThis.String(object.title) : '',
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '',
      isEval: isSet(object.isEval)
        ? globalThis.Boolean(object.isEval)
        : isSet(object.is_eval)
          ? globalThis.Boolean(object.is_eval)
          : false,
      turns: globalThis.Array.isArray(object?.turns)
        ? object.turns.map((e: any) => SessionTurn.fromJSON(e))
        : [],
    }
  },

  toJSON(message: SessionDetail): unknown {
    const obj: any = {}
    if (message.sessionId !== '') {
      obj.sessionId = message.sessionId
    }
    if (message.userId !== '') {
      obj.userId = message.userId
    }
    if (message.title !== '') {
      obj.title = message.title
    }
    if (message.createdAt !== '') {
      obj.createdAt = message.createdAt
    }
    if (message.isEval !== false) {
      obj.isEval = message.isEval
    }
    if (message.turns?.length) {
      obj.turns = message.turns.map((e) => SessionTurn.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SessionDetail>, I>>(base?: I): SessionDetail {
    return SessionDetail.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SessionDetail>, I>>(object: I): SessionDetail {
    const message = createBaseSessionDetail()
    message.sessionId = object.sessionId ?? ''
    message.userId = object.userId ?? ''
    message.title = object.title ?? ''
    message.createdAt = object.createdAt ?? ''
    message.isEval = object.isEval ?? false
    message.turns = object.turns?.map((e) => SessionTurn.fromPartial(e)) || []
    return message
  },
}

function createBaseSessionSummary(): SessionSummary {
  return { sessionId: '', title: '', createdAt: '', isEval: false }
}

export const SessionSummary: MessageFns<SessionSummary> = {
  encode(message: SessionSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sessionId !== '') {
      writer.uint32(10).string(message.sessionId)
    }
    if (message.title !== '') {
      writer.uint32(18).string(message.title)
    }
    if (message.createdAt !== '') {
      writer.uint32(26).string(message.createdAt)
    }
    if (message.isEval !== false) {
      writer.uint32(32).bool(message.isEval)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SessionSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSessionSummary()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.sessionId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.title = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.createdAt = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.isEval = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SessionSummary {
    return {
      sessionId: isSet(object.sessionId)
        ? globalThis.String(object.sessionId)
        : isSet(object.session_id)
          ? globalThis.String(object.session_id)
          : '',
      title: isSet(object.title) ? globalThis.String(object.title) : '',
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '',
      isEval: isSet(object.isEval)
        ? globalThis.Boolean(object.isEval)
        : isSet(object.is_eval)
          ? globalThis.Boolean(object.is_eval)
          : false,
    }
  },

  toJSON(message: SessionSummary): unknown {
    const obj: any = {}
    if (message.sessionId !== '') {
      obj.sessionId = message.sessionId
    }
    if (message.title !== '') {
      obj.title = message.title
    }
    if (message.createdAt !== '') {
      obj.createdAt = message.createdAt
    }
    if (message.isEval !== false) {
      obj.isEval = message.isEval
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SessionSummary>, I>>(base?: I): SessionSummary {
    return SessionSummary.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SessionSummary>, I>>(object: I): SessionSummary {
    const message = createBaseSessionSummary()
    message.sessionId = object.sessionId ?? ''
    message.title = object.title ?? ''
    message.createdAt = object.createdAt ?? ''
    message.isEval = object.isEval ?? false
    return message
  },
}

function createBaseGetSessionResponse(): GetSessionResponse {
  return { session: undefined }
}

export const GetSessionResponse: MessageFns<GetSessionResponse> = {
  encode(message: GetSessionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.session !== undefined) {
      SessionDetail.encode(message.session, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSessionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetSessionResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.session = SessionDetail.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetSessionResponse {
    return { session: isSet(object.session) ? SessionDetail.fromJSON(object.session) : undefined }
  },

  toJSON(message: GetSessionResponse): unknown {
    const obj: any = {}
    if (message.session !== undefined) {
      obj.session = SessionDetail.toJSON(message.session)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetSessionResponse>, I>>(base?: I): GetSessionResponse {
    return GetSessionResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetSessionResponse>, I>>(object: I): GetSessionResponse {
    const message = createBaseGetSessionResponse()
    message.session =
      object.session !== undefined && object.session !== null
        ? SessionDetail.fromPartial(object.session)
        : undefined
    return message
  },
}

function createBaseListSessionsResponse(): ListSessionsResponse {
  return { sessions: [] }
}

export const ListSessionsResponse: MessageFns<ListSessionsResponse> = {
  encode(message: ListSessionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.sessions) {
      SessionSummary.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListSessionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListSessionsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.sessions.push(SessionSummary.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ListSessionsResponse {
    return {
      sessions: globalThis.Array.isArray(object?.sessions)
        ? object.sessions.map((e: any) => SessionSummary.fromJSON(e))
        : [],
    }
  },

  toJSON(message: ListSessionsResponse): unknown {
    const obj: any = {}
    if (message.sessions?.length) {
      obj.sessions = message.sessions.map((e) => SessionSummary.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ListSessionsResponse>, I>>(base?: I): ListSessionsResponse {
    return ListSessionsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListSessionsResponse>, I>>(
    object: I
  ): ListSessionsResponse {
    const message = createBaseListSessionsResponse()
    message.sessions = object.sessions?.map((e) => SessionSummary.fromPartial(e)) || []
    return message
  },
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
